module.exports = __webpack_public_path__ + "static/media/img-certificate-logo.f020abc4.png";